"use client";

// global-error replaces the root layout, so it owns the document and styles.
import "~/app/styles.css";

export { GlobalErrorShell as default } from "@repo/design-system/components/error-pages/global-error-shell";
